<template>
  <div class="dashboard-page-cont dashboard-mymail">
    <div class="dashboard-mymail-head">
      <span class="model-title">我的营销邮件</span>
      <router-link class="model-more" :to="{name: 'mail-list'}">查看全部 <i class="el-icon-arrow-right"></i> </router-link>
    </div>
    <ul class="mymail-cont">
      <li class="mymail-item">
        <a class="mymail-item-link" href="javascript:(void 0)">
          <span class="mymail-item-value">{{ sendTotal }}</span>
          <p class="mymail-item-label">发件总数</p>
        </a>
      </li>
      <li class="mymail-item">
        <a class="mymail-item-link" href="javascript:(void 0)">
          <span class="mymail-item-value">{{ sendArrivedNum }}</span>
          <p class="mymail-item-label">送达总数</p>
        </a>
      </li>
      <li class="mymail-item">
        <a class="mymail-item-link" href="javascript:(void 0)">
          <span class="mymail-item-value">{{ sendedRatio }}<b class="percent">%</b></span>
          <p class="mymail-item-label">送达率</p>
        </a>
      </li>
      <li class="mymail-item">
        <a class="mymail-item-link" href="javascript:(void 0)">
          <span class="mymail-item-value">{{ openUniqueNum }}</span>
          <p class="mymail-item-label">打开人数</p>
        </a>
      </li>
      <li class="mymail-item">
        <a class="mymail-item-link" href="javascript:(void 0)">
          <span class="mymail-item-value">{{ openedRatio }}<b class="percent">%</b></span>
          <p class="mymail-item-label">打开率</p>
        </a>
      </li>
      <li class="mymail-item">
        <a class="mymail-item-link" href="javascript:(void 0)">
          <span class="mymail-item-value">{{ unsubscribeNum }}</span>
          <p class="mymail-item-label">退订总数</p>
        </a>
      </li>
      <li class="mymail-item">
        <a class="mymail-item-link" href="javascript:(void 0)">
          <span class="mymail-item-value">{{ clickNum }}</span>
          <p class="mymail-item-label">打开次数</p>
        </a>
      </li>

    </ul>
  </div>
</template>

<script>
import { getEmailStatusNum } from '@/utils/api/dashboard';

export default ({
  data() {
    return {
      sendTotal: 0, //发送总数
      sendArrivedNum: 0,  //送达总数
      openUniqueNum: 0, //打开人数
      unsubscribeNum: 0,  //退订总数
      clickNum: 0,  //点击数

      sendedRatio: 0, //送达率 = 送达总数 / 发送总数
      openedRatio: 0, //打开率 = 打开人数 / 送达总数
    }
  },
  methods: {
    getEmailStatusNum() {
      getEmailStatusNum()
        .then(res=> {
            if(res.rspResult.bizCode == 200) {
              this.sendTotal = res.data.sendTotal || 0;
              this.sendArrivedNum = res.data.sendArrivedNum || 0;
              this.openUniqueNum = res.data.openUniqueNum || 0;
              this.unsubscribeNum = res.data.unsubscribeNum || 0;
              this.clickNum = res.data.clickNum || 0;
              console.log(res.data)
              // this.sendTotal && (this.sendedRatio = Math.floor(this.sendArrivedNum / this.sendTotal * 10000) / 10000 * 100);
              // this.sendArrivedNum && (this.openedRatio = Math.floor(this.openUniqueNum / this.sendArrivedNum * 10000) / 10000 * 100);

              this.sendTotal && (this.sendedRatio = (this.sendArrivedNum / this.sendTotal* 10000/100).toFixed(2));
              this.sendArrivedNum && (this.openedRatio =(this.openUniqueNum / this.sendArrivedNum* 10000/100).toFixed(2));
            }
          })
          .catch(err=> {
            console.error('获取匹配询盘、邀请报价、授盘待接受、生产进度、待评价 的气泡数量失败', err)
          })
    }
  },
  created() {
    this.getEmailStatusNum();
  }
})
</script>


<style lang="scss" scoped>
.dashboard-mymail {
  background: #fff;
  padding: 20px 0 4px 20px;
  &-head {
    display: flex;
    padding-right: 20px;
    .model-more {
      margin-left: auto;
      height: 14px;
      line-height: 14px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #16181A;
      letter-spacing: 0;
    }
  }
  .mymail-cont {
    display: flex;
    flex-wrap: wrap;
    .mymail-item {
      width: calc((100% - 64px) / 4);
      // width: 168px;
      height: 80px;
      user-select: none;
      margin-bottom: 16px;
      margin-right: 16px;
      &-link {
        height: 100%;
        box-sizing: border-box;
        display: block;
        padding: 16px 20px;
        background: #F5F7FA;
        .mymail-item-value {
          display: inline-block;
          height: 22px;
          line-height: 22px;
          font-family: Arial;
          font-weight: Bold;
          font-size: 20px;
          color: #16181A;
          letter-spacing: 0;
          margin-bottom: 12px;
          .percent {
            display: inline-block;
            font-size: 14px;
            font-weight: bolder;
            height: 22px;
            line-height: 22px;
            vertical-align: middle;
          }
        }
        .mymail-item-label {
          height: 14px;
          line-height: 14px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #16181A;
          letter-spacing: 0;
        }
        &:hover {
          // background: #F1F7FA;
          cursor: auto;
        }
      }
    }
  }
}

</style>